import CheckoutPage from 'navigation/pages/CheckoutPage';
import Form from 'components/form/Form';
class ReturnsSummary extends CheckoutPage {
    initialized() {
        super.initialized();
    }
    getModulesMap() {
        return {
            form: ['.returns__items-form', Form],
        };
    }
}
export default ReturnsSummary;
